export default "__VITE_ASSET__Dxk1ljng__"